import { AutomotiveAftermarketListFiltersModelOutput } from '../state/monitoring/automotive-aftermarket/models';
import { TransportListFiltersDatepickerRangeOutput } from '../state/monitoring/transport/models';
import { UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { EventEmitter } from '@angular/core';
import {
  TransportManagementFilterName,
  TransportManagementFiltersOutputModel,
} from '../state/monitoring/transport-management';
import {
  AllocationViewFilterName,
  AllocationViewListFiltersBaseModel,
  AllocationViewListFiltersModelOutput,
} from '../state/monitoring/allocation-view';
import { DeliveryService, Origin, ServiceLevel, TransportFilterName } from '../state/monitoring/transport/constants';
import { ListViewMode } from '../state/monitoring/constants';
import { ShipmentFilterName } from '../state/monitoring/shipment/constants';
import { AddressListFiltersModelBase, AddressManagementFilterName } from '../state/address';
import {
  ApiConnectionFilterModelBase,
  CompartmentUserListFiltersModelBase,
  PartnerListFiltersModelBase,
  UserListFiltersModelBase,
} from '../state/administration';
import { TruckStatus, UliOrigin, UliStatus } from '../../common/constants';
import { FailedMessageFilterName, FailedMessageFiltersDatepickerRangeOutput } from '../state/data-quality';
import { ShipmentFiltersDatepickerRangeOutput } from '../state/monitoring/shipment';

export type FilterName =
  | AllocationViewFilterName
  | TransportFilterName
  | TransportManagementFilterName
  | MonitoringFilterNameDictionary
  | AddressManagementFilterName
  | ShipmentFilterName
  | FailedMessageFilterName;

export type FiltersModel =
  | AllocationViewListFiltersBaseModel
  | UserListFiltersModelBase
  | AddressListFiltersModelBase
  | ApiConnectionFilterModelBase
  | PartnerListFiltersModelBase
  | CompartmentUserListFiltersModelBase;

export interface ListFilter {
  title: FilterName;
  values: unknown[];
}

export type FiltersDatepickerRangeOutput =
  | AllocationViewListFiltersModelOutput
  | AutomotiveAftermarketListFiltersModelOutput
  | TransportListFiltersDatepickerRangeOutput
  | TransportManagementFiltersOutputModel
  | FailedMessageFiltersDatepickerRangeOutput
  | ShipmentFiltersDatepickerRangeOutput;

export type FilterValueUpperCaseUnionType = Origin | UliOrigin | DeliveryService | ServiceLevel;

export type FilterValueSentenceCaseUnionType = UliOrigin | UliStatus | TruckStatus;

export interface FiltersService {
  filtersValue: FiltersDatepickerRangeOutput;
  filtersForm: UntypedFormGroup;
  activeFilterNameList$: BehaviorSubject<FilterName[]>;
  resetFilterForm$: EventEmitter<void | boolean>;
  resetFilterGroup$: EventEmitter<FilterName>;
}

export type TransportListViewMode = ListViewMode[];

export enum MonitoringFilterNameDictionary {
  ActualArrivalTime = 'actualArrivalTime',
  ActualDepartureTime = 'actualDepartureTime',
  BarcodeIds = 'barcodeIds',
  BoschOrderNumbers = 'boschOrderNumbers',
  Carriers = 'carriers',
  Consignees = 'consignees',
  Consignors = 'consignors',
  CustomerMaterialNumbers = 'customerMaterialNumbers',
  CustomerOrderNumbers = 'customerOrderNumbers',
  DeliveryNoteNumbers = 'deliveryNoteNumbers',
  DeliveryServices = 'deliveryServices',
  DeviationTypes = 'deviationTypes',
  EquipmentId = 'equipmentId',
  EstimatedArrivalTime = 'estimatedArrivalTime',
  EstimatedDepartureTime = 'estimatedDepartureTime',
  FreightModes = 'freightModes',
  FreightPayers = 'freightPayers',
  HouseAirwayBills = 'houseAirwayBills',
  HuIds = 'huIds',
  IStarNumbers = 'iStarNumbers',
  LoadNumbers = 'loadNumbers',
  LspTrackingNumbers = 'lspTrackingNumbers',
  BoschMaterialNumbers = 'boschMaterialNumbers',
  Origins = 'origins',
  Pickups = 'pickups',
  PlannedArrivalTime = 'plannedArrivalTime',
  PlannedDepartureTime = 'plannedDepartureTime',
  RbPoNumber = 'rbPoNumber',
  ReasonCodes = 'reasonCodes',
  Regions = 'regions',
  RouteIds = 'routeIds',
  SapIds = 'sapIds',
  ServiceLevels = 'serviceLevels',
  ShipTos = 'shipTos',
  StatusCodes = 'statusCodes',
  StatusDate = 'statusDate',
  Statuses = 'statuses',
  TransportModes = 'transportModes',
  TransportNumbers = 'transportNumbers',
  TransportOrderNumbers = 'transportOrderNumbers',
  UnNumber = 'unNumber',
  BusinessUnits = 'businessUnits',
  NetworkParts = 'networkParts',
  ConsignorAddresses = 'consignorAddresses',
  SapClientViews = 'sapClientViews',
}

export enum UserItemEnum {
  Roles = 'Roles',
  Locations = 'Locations',
  Country = 'Country',
  TimeZone = 'Timezone',
}
